<template>
  <div>
    <h1 class="title-page">
      <v-icon class="material-icons-outlined">import_contacts</v-icon>
      <br />年度・期間を選択
    </h1>

    <v-card class="card">
      <h2 class="title-bar">製本するお子さま</h2>
      <section>
        園・施設名： {{ organizationName }}<br />
        名前：{{ familyName }} {{ selectedKid.name }}
      </section>

      <h2 class="title-bar">商品情報</h2>
      <section>
        <v-layout row justify-content-space-between align-end>
          <v-flex xs8>
            <span class="item-title">連絡帳製本</span>
            サイズ：A5サイズ<br />
            ページ数：96ページ<br />
            価格：{{ price }}円（税込）
          </v-flex>
          <v-flex xs4 class="text-xs-right">
            <a
              href=""
              class="bold"
              @click.prevent="$emit('show-product-detail-full-screen-dialog')"
              >商品詳細を見る</a
            >
          </v-flex>
        </v-layout>
      </section>

      <h2 class="title-bar">年度を選択</h2>
      <section>
        <v-select
          v-model="localSelectedYear"
          :items="years"
          item-text="text"
          item-value="value"
          label="利用年度を事前にご確認ください"
          no-data-text="選択可能な年度がありません。"
          outline
          :hide-details="true"
        ></v-select>
      </section>

      <h2 class="title-bar">期間を選択</h2>
      <section>
        <v-select
          v-model="localSelectedPeriod"
          :items="periods"
          :disabled="!localSelectedYear"
          item-disabled="disabled"
          item-text="text"
          return-object
          label="利用期間を事前にご確認ください"
          no-data-text="選択可能な期間がありません。"
          outline
          :hide-details="true"
        ></v-select>
        <p class="subtext">
          【ご購入のタイミングと写真掲載について】<br />
          ※
          製本の購入は、対象となる3ヶ月の期間が終了した翌月の1日から選択ができます。<br />
          ※ 2025年9月期以前の連絡帳に写真掲載することができません。<br />
          <a
            href="https://lookmee.tayori.com/q/lookmee-faq-c/detail/1168334/"
            target="_blank"
            rel="noopener"
            >よくある質問<v-icon small color="primary">open_in_new</v-icon></a
          >からご確認ください。
        </p>
        <p class="attention-text">
          【必ずご確認ください】<br />
          この製本は、ルクミー連絡帳が対象です。実際に記録された日数を問わず、選択した期間のルクミー連絡帳の記録を印刷します。
          事前にルクミー for FAMILY アプリで記録内容のご確認をお願いします。
        </p>
      </section>

      <v-layout justify-center column pb-4 align-center>
        <v-btn
          class="v-btn--minwidth"
          color="primary"
          :disabled="!localSelectedYear || !localSelectedPeriod"
          @click="handleNext"
        >
          次へ進む
        </v-btn>

        <v-btn class="v-btn--minwidth" color="negative" @click="$emit('back')">
          戻る
        </v-btn>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import periodsUtil from "../Periods";

export default {
  name: "SelectPeriod",
  props: {
    price: {
      type: String,
      default: ""
    },
    familyName: {
      type: String,
      default: null
    },
    organizationName: {
      type: String,
      default: null
    },
    selectedKid: {
      type: Object,
      default: null
    },
    selectedYear: {
      type: Number,
      default: null
    },
    selectedPeriod: {
      type: Object,
      default: null
    }
  },
  computed: {
    years() {
      return this.selectedKid.belongsGroupYears.map(year => ({
        text: `${year}年度`,
        value: year
      }));
    },
    localSelectedYear: {
      get() {
        return this.selectedYear;
      },
      set(value) {
        this.$emit("update:selectedYear", value);
      }
    },
    periods() {
      if (!this.selectedYear) {
        return [];
      }

      // Periodオブジェクトそのものをitemsとして渡す
      return periodsUtil.list(this.selectedYear);
    },
    localSelectedPeriod: {
      get() {
        return this.selectedPeriod;
      },
      set(value) {
        this.$emit("update:selectedPeriod", value);
      }
    }
  },
  watch: {
    localSelectedYear(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$emit("update:selectedPeriod", null);
      }
    }
  },
  methods: {
    handleNext() {
      this.$emit("next");
    }
  }
};
</script>

<style scoped>
.card {
  max-width: 443px;
}
.card section {
  padding: 16px;
}
.item-title {
  font-size: 16px;
  display: block;
  margin-bottom: 8px;
}
.subtext {
  margin-top: 16px;
  font-size: 12px;
}
.attention-text {
  font-size: 12px;
  color: #fa6053;
}
</style>
